
import { Options, Vue } from "vue-class-component";
import { Voucher } from "@/models/voucher";
import { PropType } from "@vue/runtime-core";

@Options({
  props: {
    voucher: {
      type: Object as PropType<Voucher>,
      require: true,
    },
  },
  emits: ["payVoucher"],
})
export default class VoucherCard extends Vue {
  voucher!: Voucher;

  payVoucher(): void {
    this.$emit("payVoucher");
  }

  get totalValue(): string {
    const totalValue =
      this.voucher.totalAmount ||
      this.voucher.entries.reduce((x, e) => x + e.amount, 0);
    return this.formatCurrency(totalValue);
  }

  formatCurrency(value: number): string {
    const v = Math.abs(Math.round(value)).toString();
    return (value < 0 ? "-$" : "$") + v.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
}
